import { split, map, capitalize, join } from "lodash";
import { Link } from "react-router-dom";
import { ProgressSpinner } from "primereact/progressspinner";
import useApp from "hooks/useApp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as SolidIcons from "@fortawesome/free-solid-svg-icons";
import Module from "./Module";

export default function CompleteModules(props) {
  const app = useApp();

  const { modules, modulesInProgress } = app;

  const hypenToCapCase = (val) => {
    const arr = split(val, "-");
    const updatedArr = map(arr, (str) => capitalize(str));
    return join(updatedArr, "");
  };

  return (
    <div
      className="container-fluid"
      style={{ fontFamily: "Poppins, sans-serif" }}
    >
      <i
        className="pi pi-arrow-circle-left w-10 h-10 cursor-pointer"
        onClick={() => app.navigate("/home")}
        style={{ fontSize: "2rem" }}
      />
      {modulesInProgress ? (
        <ProgressSpinner
          style={{ position: "absolute", top: "50%", left: "50%" }}
        />
      ) : modules.length > 0 ? (
        <div className="w-full rounded h-full flex gap-3 flex-wrap">
          {modules.map((module) => {
            const {
              id,
              code,
              icon,
              module_name,
              patient_count,
              percentage,
              color,
            } = module;
            return (
              <Module
                key={id}
                icon={icon}
                title={module_name}
                patient_count={patient_count}
                percentage={percentage}
                bgColor={color}
                onClick={() => app.navigate(`/dashboard/${module.id}?legend=0`)}
                moduleId={id}
                flex={"0 0 calc(33.33% - 10px)"}
              />
            );
          })}
        </div>
      ) : (
        <div
          style={{
            height: "350px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <span className="text-xl text-400 font-bold">No Modules found</span>
        </div>
      )}
    </div>
  );
}
